export default __webpack_public_path__ + "static/media/bg4.03d0cbff.mp4";